import {
  Flex,
  FlexItem,
  InputNumber,
  Panel,
  RadioButton,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { step4State } from 'Pages/Workflow/recoil/state/step4'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const MailingFrequency = () => {
  const intl = useIntl()
  const [{ FrequencySafeGuard }, setWorkflowDetails] =
    useRecoilState(step4State)
  const [frequencyType, setFrequencyType] = useState(
    FrequencySafeGuard > 0 ? 'interval' : 'once'
  )

  const handleRadioButton = (event) => {
    setFrequencyType(event.target.value)
  }

  const handleHoursChange = (value) => {
    setWorkflowDetails((prev) => ({
      ...prev,
      FrequencySafeGuard: value
    }))
  }

  useEffect(() => {
    if (frequencyType === 'once') {
      setWorkflowDetails((prev) => ({
        ...prev,
        FrequencySafeGuard: 0
      }))
    } else {
      setWorkflowDetails((prev) => ({
        ...prev,
        FrequencySafeGuard: FrequencySafeGuard > 1 ? FrequencySafeGuard : 1
      }))
    }
  }, [frequencyType])

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.TriggersDetail.TitleFrequenza' })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Flex alignItems='baseline'>
        <RadioButton
          label={intl.formatMessage({ id: 'Load.TriggersDetail.OnlyOnce' })}
          checked={frequencyType === 'interval'}
          value={'interval'}
          onChange={handleRadioButton}
        />
        <FlexItem width='80px' margin='0 8px 0 0'>
          <InputNumber
            value={FrequencySafeGuard}
            onChange={handleHoursChange}
            disabled={frequencyType === 'once'}
            min={1}
            max={999}
            variant={
              frequencyType === 'interval' && FrequencySafeGuard < 1
                ? 'danger'
                : undefined
            }
            precision={0}
          />
        </FlexItem>
        <Text variant={TEXT_VARIANT_BOLD}>
          {intl.formatMessage({ id: 'Load.TriggersDetail.Hours' })}
        </Text>
      </Flex>
      <SpacingVertical variant={SPACING_8} />
      <RadioButton
        label={intl.formatMessage({ id: 'Load.TriggersDetail.OnlyOnceOne' })}
        checked={frequencyType === 'once'}
        value={'once'}
        onChange={handleRadioButton}
      />
    </Panel>
  )
}

export default MailingFrequency
